import React, { useEffect, useRef } from 'react'
import ReactMarkdown from 'react-markdown'
import renderMathInElement from 'katex/dist/contrib/auto-render'

import { useStyles } from './markdown-block.style'

export const MarkdownBlock = function ({ report, ...props }) {
  const classes = useStyles()
  const contentRef = useRef()

  useEffect(() => {
    renderMathInElement(contentRef.current, {
      // This is the default value without 'code'
      // Need to use backticks in markdown to allow inline expressions without markdown adding newlines
      ignoredTags: ['script', 'noscript', 'style', 'textarea', 'pre']
    })
  }, [])

  return <div className={classes.content} ref={contentRef}>
    <ReactMarkdown {...props} />
  </div>
}
